import { IGroup } from "../types/group.types";

export function sorterByStartDate<T extends IGroup>(a: T, b: T) {
  return (
    new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
  );
}

